import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { Button, Modal } from "components/AtomsV2";
import { Icon } from "components/ShellV2";
import { hasValidityPeriodChanged } from "utils/businessValidity";

function BusinessValidityChangeNotice({
  originalStartDate,
  originalEndDate,
  startDate,
  endDate,
  enabled,
  className,
}) {
  const [helpOpen, setHelpOpen] = useState(false);
  const { t } = useTranslation(["common"]);
  const changed =
    enabled &&
    hasValidityPeriodChanged({
      originalStartDate,
      originalEndDate,
      startDate,
      endDate,
    });

  if (!changed) return null;

  return (
    <>
      <div
        className={`flex items-center gap-2 rounded-[var(--radius-sm)] px-3 py-2 text-[12.5px] ${className}`}
        style={{
          color: "var(--warning)",
          background: "var(--warning-soft)",
          border: "1px solid color-mix(in srgb, var(--warning) 28%, transparent)",
        }}
        role="status"
      >
        <Icon name="warning" style={{ fontSize: 18, flexShrink: 0 }} />
        <span className="font-semibold flex-1">{t("businessValidity.changedWarning")}</span>
        <button
          type="button"
          className="inline-flex items-center justify-center w-7 h-7 rounded-full border-0 bg-transparent cursor-pointer"
          style={{ color: "var(--warning)" }}
          aria-label={t("businessValidity.helpButton")}
          title={t("businessValidity.helpButton")}
          onClick={() => setHelpOpen(true)}
        >
          <Icon name="help_outline" style={{ fontSize: 20 }} />
        </button>
      </div>

      <Modal
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        title={t("businessValidity.helpTitle")}
        subtitle={t("businessValidity.helpIntro")}
        maxWidth={560}
        footer={<Button onClick={() => setHelpOpen(false)}>{t("businessValidity.close")}</Button>}
      >
        <div className="mt-4 text-[13.5px] leading-6 text-ink-2">
          <p className="mt-0">{t("businessValidity.exampleIntro")}</p>
          <ul className="pl-5 mb-0 list-disc">
            <li>{t("businessValidity.exampleOriginal")}</li>
            <li>{t("businessValidity.exampleBefore")}</li>
            <li>{t("businessValidity.exampleSelection")}</li>
            <li>{t("businessValidity.exampleAfter")}</li>
          </ul>
          <p className="mb-0 mt-4">{t("businessValidity.calculationNote")}</p>
        </div>
      </Modal>
    </>
  );
}

BusinessValidityChangeNotice.propTypes = {
  originalStartDate: PropTypes.string,
  originalEndDate: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  enabled: PropTypes.bool,
  className: PropTypes.string,
};

BusinessValidityChangeNotice.defaultProps = {
  originalStartDate: "",
  originalEndDate: "",
  startDate: "",
  endDate: "",
  enabled: true,
  className: "",
};

export default BusinessValidityChangeNotice;
